<template>
    <v-edit-dialog
        v-if="isAdmin && !contract.deletedAt"
        large
        @save="save"
        @close="setDefaultStatus"
    >
        <v-chip small dark :color="status === 'signed' ? 'green' : 'blue'">
            {{ status }}
        </v-chip>

        <template #input>
            <v-select v-model="status" :items="['pending', 'signed']" />
        </template>
    </v-edit-dialog>

    <v-chip v-else small dark :color="status === 'signed' ? 'green' : 'blue'">
        {{ status }}
    </v-chip>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        contract: {
            type: Object,
            required: false,
            default: () => {}
        }
    },

    data() {
        return {
            status: 'pending'
        };
    },

    computed: {
        ...mapGetters({ isAdmin: 'auth/isAdmin' })
    },

    watch: {
        contract() {
            this.setDefaultStatus();
        }
    },

    created() {
        this.setDefaultStatus();
    },

    methods: {
        ...mapActions({ changeStatus: 'contracts/changeStatus' }),

        setDefaultStatus() {
            this.status = 'pending';

            if (this.contract) {
                this.status = this.contract.status;
            }
        },

        async save() {
            try {
                await this.changeStatus({
                    contractId: this.contract.id,
                    status: this.status
                });

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('createOrUpdateContract.editTitle'),
                    text: this.$t('createOrUpdateContract.saveSuccess')
                });
            } catch (err) {
                console.error(err);

                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: this.$t('createOrUpdateContract.editTitle'),
                    text: 'Unexpected error occurred...'
                });
            }
        }
    }
};
</script>
